(()=>{
 const update=root=>{
  for(const badge of root.querySelectorAll('[data-organic-badge]')){
   const label=window.OrganicMaterial.labelFor(badge.dataset.organicDescription||'',badge.dataset.organicOverride||'');
   const text=badge.querySelector('[data-organic-label]');
   if(text.textContent!==label)text.textContent=label;
   badge.hidden=!label;
  }
 };
 const start=()=>{update(document);new MutationObserver(records=>{for(const record of records){for(const node of record.addedNodes)if(node.nodeType===1){if(node.matches('[data-organic-badge]'))update(node.parentElement);else update(node);}}}).observe(document.body,{subtree:true,childList:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
